import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterConsultantPage() {
  return <ClusterPageTemplate clusterName="Consultant" sectorName="Coaches & Consultants" sectorSlug="coaches-consultants" heroTitle="Website laten maken voor een consultant" heroDescription="Een strakke, zakelijke website voor jouw consultancybureau of interim praktijk. Wij bouwen websites die autoriteit uitstralen naar B2B opdrachtgevers." websiteOnderdelen={[{
    icon: 'BriefcaseIcon',
    title: 'Expertise & Diensten',
    description: 'Een heldere uiteenzetting van jouw vakgebied, methodiek en de specifieke diensten die je aanbiedt.'
  }, {
    icon: 'FileTextIcon',
    title: 'Cases & Track Record',
    description: 'Overtuig opdrachtgevers met uitgebreide case studies van succesvolle projecten en behaalde resultaten.'
  }, {
    icon: 'UsersIcon',
    title: 'Over het bureau',
    description: 'Jouw visie, achtergrond, werkervaring en eventueel het team van consultants.'
  }, {
    icon: 'BookOpenIcon',
    title: 'Kennisbank / Whitepapers',
    description: 'Deel je thought leadership via diepgaande artikelen, whitepapers en onderzoeksrapporten.'
  }]} functionaliteiten={[{
    icon: 'FileTextIcon',
    title: 'Leadgeneratie formulieren',
    description: 'Gated content: verzamel B2B leads door whitepapers of rapporten aan te bieden in ruil voor gegevens.'
  }, {
    icon: 'LaptopIcon',
    title: 'LinkedIn integratie',
    description: 'Koppel je professionele profiel en deel eenvoudig je website content op zakelijke netwerken.'
  }, {
    icon: 'SearchIcon',
    title: 'B2B SEO',
    description: 'Optimalisatie voor specifieke, zakelijke zoektermen binnen jouw niche of branche.'
  }]} siblingClusters={[{
    name: 'Coaching',
    slug: 'coaching'
  }, {
    name: 'Sportschool',
    slug: 'sportschool'
  }, {
    name: 'Personal Trainer',
    slug: 'personal-trainer'
  }]} faqs={[{
    q: 'Hoe straalt de website voldoende senioriteit uit?',
    a: 'We gebruiken een strak, minimalistisch design met zakelijke typografie, hoogwaardige fotografie en een focus op inhoud en resultaten (cases).'
  }, {
    q: 'Kan ik whitepapers aanbieden in ruil voor e-mailadressen?',
    a: "Ja, we kunnen 'gated content' modules inbouwen. Bezoekers vullen hun gegevens in en ontvangen daarna automatisch de whitepaper in hun mail."
  }, {
    q: 'Wat kost een website voor een consultant?',
    a: 'Een professionele, zakelijke website start vanaf €1.500. Afhankelijk van de hoeveelheid cases en leadgeneratie-modules maken we een offerte op maat.'
  }, {
    q: 'Is de website makkelijk zelf te beheren?',
    a: 'Zeker. Via het WordPress CMS kun je zelf eenvoudig nieuwe cases toevoegen, blogs publiceren of je dienstenpakket updaten.'
  }]} data-id="element-1068" data-mp="2alvffb5leuoy" />;
}